import { useMemo } from 'react';
import { weekdayNames } from '@src/common/calendar';
import { useTranslate } from '@src/core/hooks';

const ABBR_LENGTH = 3;

export type WeekdayFormatter = {
  names: string[];
  format: (date: Date) => string;
};

export function useWeekdayFormatter(): WeekdayFormatter {
  const { i18n } = useTranslate();
  return useMemo(() => {
    const translate = i18n as (key: string) => string;
    const names = weekdayNames.map((name) => translate(name).substring(0, ABBR_LENGTH));
    const format = (date: Date) => names[date.getDay()] ?? '';
    return { names, format };
  }, [i18n]);
}
